import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbAccordionItem } from '@ng-bootstrap/ng-bootstrap';
import { DataService, IHttpCallBack } from '../../../../Shared-Lib/services/data.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { NGXLogger } from 'ngx-logger';
import { SearchClass, Menu, Menu_Search } from '../model/menu';
import { catchError, map, tap } from 'rxjs/operators';
import { DialogService } from '../../../../Shared-Lib/component/dialog/dialog.service';
import { FilterDataService } from '../services/filter-data.service';
import { SelectListItem } from '../lib/select/select-property';
import { AppService } from '../services/app.service';
import { TableSetting } from '../../../../Shared-Lib/component/table/table-class';
import { ReturnClass } from '../../../../Shared-Lib/model/search-result';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})

export class MenuComponent {

  @ViewChild('acc') acc: NgbAccordionItem; //link to ngAfterViewInit().
  model: Menu_Search;
  ControllerName = 'Menu';
  // displayedColumns: string[] = ['parent', 'menutitle', 'enabled', 'display'];
  //傳入 DataTable 資料之變數
  TableData: ReturnClass;
  currentRoute: string;
  // sampleMenu: any[];

  userPermission: any;
  TableSetting: TableSetting;

  CanCreate: boolean = true;
  CanDelete: boolean = true;
  CanEdit: boolean = true;

  constructor(private dataSer: DataService,
    private DlgService: DialogService, private app: AppService,
    private router: Router, private filterService: FilterDataService) {
    this.model = new Menu_Search();

    this.TableSetting = new TableSetting();
    this.TableSetting.CanUpdate = true;
    this.TableSetting.CanDelete = true;
    this.TableSetting.IdColumnName = 'MenuID';
    this.TableSetting.ItemTitle = (element: Menu) => {
      return `${element.MenuTitle}`;
    };
    this.TableSetting.CorrespondTableHeard = [
      { columnDef: 'Parent', header: 'Parent', cell: (element: Menu) => `${element.Parent}` },
      { columnDef: 'MenuTitle', header: 'Menu Title', cell: (element: Menu) => `${element.MenuTitle}` },
      { columnDef: 'OrderSeq', header: 'Order Sequence', cell: (element: Menu) => `${element.OrderSeq}` },
      { columnDef: 'IsDisplayed', header: 'IsDisplayed', cell: (element: Menu) => `${element.IsDisplayed ? "Y" : "N"}` },
    ];

    this.dataSer.getData(this.ControllerName + '/init', null,
      (data) => {
        this.model.ddlParent = new Array<SelectListItem>();
        let i = 1;
        data.Menus.forEach(it => {
          let o: SelectListItem = {
            value: it.MenuID,
            text: it.MenuTitle,
            index: i++
          };
          this.model.ddlParent.push(o);
        });
        const firstItem: SelectListItem = { value: '-1', text: 'All the below', index: 0 };
        const SecondItem: SelectListItem = { value: '0', text: 'Root', index: 1 };
        this.model.ddlParent.unshift(SecondItem);
        this.model.ddlParent.unshift(firstItem);
        this.model.filter.MenuPID = '-1';
      });
  }

  ngOnInit() {
    setTimeout(() => this.app.SetLoadingState(true), 0);
    this.currentRoute = this.router.url;
    this.Search();
  }

  ngAfterViewInit() {
    // ngb-accordion 需再 page init 後，才抓的到物件 : setTimeout(() => this.acc.expandAll(), 0);
  }

  Search() {
    if (this.filterService.HasUsed) {
      let LasttimeSearchInfo = this.filterService.GetSearchInfo();
      if (LasttimeSearchInfo.Filter) {
        this.model.filter = LasttimeSearchInfo.Filter;
      }
    }
    this.filterService.ChangeSearchInfo(this.currentRoute, this.model.filter);

    this.dataSer.getData(this.ControllerName + '/List', this.model.filter, (res) => {
      this.TableData = {
        draw: this.model.filter.PageIndex,
        pagingSize: this.model.filter.PageSize,
        recordsTotal: res.TotalCount,
        recordsFiltered: res.TotalCount,
        data: res.DataList
      };
    }, (res) => {
    }, (res) => {
      setTimeout(() => this.app.SetLoadingState(false), 0);
    })
  }

  //call from child component : data-source-table -> change page size function
  onChangePageInfo(PageInfo: any) {
    this.model.filter.PageSize = PageInfo.PageSize;
    this.model.filter.PageIndex = PageInfo.CurrentPage;

    this.Search();
  }

  onChangeTableInfo(TableInfo: any) {
    this.model.filter.SortBy = TableInfo.SortBy;
    this.model.filter.IsAsc = TableInfo.IsAsc;

    this.Search();
  }

  Delete(DeleteItem: any) {
    console.log('delete id', DeleteItem)
    this.app.SetLoadingState(true);
    this.dataSer.DeleteData(`${this.ControllerName}/${DeleteItem.MenuID}`, null,
      (res) => {
        console.log(res);
        this.Search();
      },
      (res) => {
        let result = this.DlgService.ErrorInformation(res.Message);
        result.then((ret) => {
        }).catch((error) => {
          console.error(error);
        });
      },
      () => {
        this.app.SetLoadingState(false);
      }
    );
  }
}
